export enum ResultsLabel {
	MASTERS = 'Masters',
	BACHELORS = 'Bachelors',
	SHORT_COURSES = 'Courses',
	PHDS = 'PhDs',
	DEFAULT = 'Results',
}
